<template>
  <div class="mod-windex show-nav">
    <div class="account" v-if="$store.state.token">
      <!-- quicklink -->
      <div class="quicklink">
        <a @click="$parent.goNav('/app')"></a>
        <a @click="$parent.goNav('/message')" id="gosystemMessage_btn" class="message pr"></a>
      </div>
      <!-- profile -->
      <div class="profile">
        <div class="profile-image">
          <img :src="$store.state.userInfo.avatar ? $store.state.userInfo.avatar : '/static/image/profile.jpg'" />
          <input class="inputsw" type="file" @change="onchangemd" single accept="image/gif,image/png" />
          <a href="javascript:void(0);"></a>
        </div>
        <a class="profile-info" @click="$parent.goNav('/setting')" id="goprofileInfo_btn">
          <p>{{ $store.state.userInfo.username }}</p>
          <span>您已加入{{ $store.state.appInfo.title }}第{{ $store.state.userInfo.joinday }}天</span>
        </a>
      </div>
      <!-- balance -->
      <div class="balance" style="display: flex; align-items: center">
        <em>钱包余额： </em>
        <span>¥ </span>
        <span id="balance">{{ $store.state.userInfo.balance }}</span>
        <i class="refresh" @click="$parent.getUserInfoShowLoding()"></i>
      </div>
    </div>
    <div class="account" v-if="!$store.state.token">
      <!-- quicklink -->
      <div class="quicklink">
        <a @click="$parent.goNav('/app')"></a>
        <a @click="$parent.goNav('/message')" id="gosystemMessage_btn" class="message pr"></a>
      </div>
      <!-- profile -->
      <div class="profile" @click="$parent.goNav('/login')">
        <div class="profile-image">
          <img src="/static/image/profile.jpg" />

          <a href="javascript:void(0);"></a>
        </div>
        <a class="profile-info" id="goprofileInfo_btn">
          <p>请登录</p>
        </a>
      </div>
      <!-- balance -->
      <div class="balance" style="display: flex; align-items: center"></div>
    </div>
    <ul class="wallet" v-if="$store.state.token">
      <li class="deposit"><a @click="$parent.goNav('/recharge')" id="godep_btn">存款</a></li>
      <li class="withdraw"><a @click="$parent.goNav('/withdrawal')" id="gowithdraw_btn">取款</a></li>
      <li class="transfer"><a @click="$parent.goNav('/transfer')" id="goplatTransf_btn">转账</a></li>
    </ul>
    <ul class="action clearfix">
      <li class="security fl" @click="$parent.goNav('/securitycenter')">
        <a id="gosecurityCentre_btn"
          ><h4>安全中心</h4>
          <p>SECURITY CENTRE</p></a
        >
      </li>
      <li class="agent fr" v-if="$store.state.token" @click="$parent.goNav('/applyagent')">
        <a id="goagentJoining_btn"
          ><h4>代理加盟</h4>
          <p>AGENT JOINING</p></a
        >
      </li>
      <li class="agent fr" v-else @click="$parent.goNav('/login')">
        <a id="goagentJoining_btn"
          ><h4>代理加盟</h4>
          <p>AGENT JOINING</p></a
        >
      </li>
    </ul>
    <ul class="record clearfix" v-if="$store.state.token">
      <li @click="$parent.goNav('/transRecord')" class="rc-htr">
        <a id="gotransRecord_btn"><i></i>交易记录</a>
      </li>
      <li class="rc-bhtr" @click="$parent.goNav('/betRecord')">
        <a id="gobetSlip_btn"><i></i>投注记录</a>
      </li>
      <li class="rc-bnhtr" @click="$parent.goNav('/fanshui')">
        <a id="gobonusReb_btn"><i></i>红利返水</a>
      </li>

      <li class="rc-acc" @click="$parent.goNav('/activityRecord')">
        <a id="gomainAcc_btn"><i></i>活动记录</a>
      </li>

      <li class="rc-acc" @click="$parent.goNav('/welfare')">
        <a id="gomainAcc_btn"><i></i>红包中心</a>
      </li>
      <li class="rc-bc" @click="$parent.goNav('/wallet?type=1')">
        <a id="gobankCardManagement_btn"><i></i>银行卡管理</a>
      </li>
      <li class="rc-cshtr" @click="$parent.goNav('/wallet?type=2')">
        <a id="goselfserHis_btn"><i></i>USDT管理</a>
      </li>
      <li class="rc-cshtr" @click="$parent.goNav('/message')">
        <a id="gomainAcc_btn"><i></i>消息中心</a>
      </li>
    </ul>

    <ul class="extlink">
      <li class="el-sport" @click="$parent.goNav('/vip')">
        <a id="goManBetSports_btn"><i></i>VIP特权</a>
      </li>
      <li class="el-about" @click="$parent.goNav('/boutBallBetInfo?type=7')">
        <a  id="aboutManBet_btn"><i></i>关于我们</a>
      </li>
      <li class="el-help" @click="$parent.goNav('/boutBallBetInfo?type=1')">
        <a  id="xiaoWanHelper_btn"><i></i>常见问题  <span style="padding-left:30px;color:#ccc">V2.1.1.20220906_pc</span></a>
      </li>
      <li class="el-contact" @click="$parent.goNav('/boutBallBetInfo?type=4')">
        <a  id="contactUs_btn"><i></i>联系我们</a>
      </li>
      <li class="el-app" @click="$parent.goNav('/gamePage?dailiD=1')">
        <a id="goManBetAPP_btn"><i></i>代理登录</a>
      </li>
            <li class="el-app" >
        <a :href="$store.state.appInfo.ios_download_url" target="_blank" id="goManBetAPP_btn"><i></i>app下载</a>
      </li>
      
    </ul>
          <div class="p15 mtb15" v-if="$store.state.token">
        <a class="confirm-sub" @click="$parent.outLogin()" id="logout_btn">退出登录</a>
      </div>
  </div>
</template>
<script>
export default {
  name: 'mine',
  data() {
    return {
      activitylistList: [],
      bfNum: 0,
      vipLis: [],
    };
  },
  created() {
    let that = this;
    that.activitylist();
    that.uservip();
  },
  methods: {
    onchangemd(e) {
      let that = this;

      console.log(e.target.files); //这个就是选中文件信息
      let formdata = new FormData();
      Array.from(e.target.files).map(item => {
        console.log(item);
        formdata.append('file', item); //将每一个文件图片都加进formdata
      });
      //  axios.post("接口地址", formdata).then(res => { console.log(res) })
      that.$parent.showLoading();

      that.$apiFun.post('/api/uploadimg', formdata).then(res => {
        that.$parent.hideLoading();

        that.$parent.getUserInfoShowLoding();
      });
    },
    uservip() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/uservip', {})
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.vipLis = res.data;
            that.getbfNum();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getbfNum() {
      let that = this;
      let num = 0; //当前vip充值钱
      let vip = that.$store.state.userInfo.vip * 1; //当前vip等级
      that.vipLis.forEach((el, index) => {
        console.log();
        if (index == vip) {
          num = el.recharge * 1;
        }
      });
      let userMey = that.$store.state.userInfo.paysum * 1;
      let bfNum = userMey == 0 || num == 0 ? 0 : Math.round((userMey / num) * 100);
      that.bfNum = bfNum > 100 ? 100 : bfNum;
      console.log(111);
    },
    transall() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.$parent.showTost(0, res.message);
          that.$parent.getUserInfoShowLoding();
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    activitylist() {
      let that = this;
      let info = that.actType == '' ? {} : { type: that.actType };
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitylist', info).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitylistList = res.data.data;
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/chunk-4deac3d0.11461b5f.css';
.mod-windex .record li a {
  font-size: 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/mine.vue